// extracted by mini-css-extract-plugin
export default {"container":"CsrIwl","legacyLists":"hBh3pp","responsiveLayout":"qO75ze","withDivider":"JSlVyv","whenThreeColumns":"BnmySN","whenTwoColumns":"TWHuR7","whenOneColumns":"yDBimX"};